import { Record } from 'immutable';
import { schema } from 'normalizr';

export const ThirdPartyCustomerRelationship = new Record({
  id: undefined,
  owner: undefined,
  third_party: undefined,
  create_one_site_group_for_entire_customer: false,
  third_party_can_relocate: true,
});

export const thirdPartyCustomerRelationshipSchema = new schema.Entity('thirdPartyCustomerRelationships', {
  third_party: new schema.Entity('thirdParties'),
});
